import { API_ROUTES } from "@/constants/api";
import { QUERY_KEYS } from "@/constants/config";
import { AUDIT_DEFAULTS } from "@/constants/audit";
import { apiGet } from "@/lib/api-client";
import { useQuery } from "@tanstack/react-query";
import type { AuditLogRow, Paginated } from "@bizy/core";

export interface LogListParams {
  page?: number;
  pageSize?: number;
  action?: string;
  resource?: string;
}

const toQuery = (params: LogListParams): string => {
  const search = new URLSearchParams();
  search.set("page", String(params.page ?? 1));
  search.set("pageSize", String(params.pageSize ?? AUDIT_DEFAULTS.pageSize));
  if (params.action) search.set("action", params.action);
  if (params.resource) search.set("resource", params.resource);
  return `?${search.toString()}`;
};

export const useAuditLogs = (workspaceId: string | undefined, params: LogListParams = {}) =>
  useQuery({
    queryKey: [QUERY_KEYS.logs, workspaceId ?? "none", params],
    enabled: Boolean(workspaceId),
    queryFn: () =>
      apiGet<Paginated<AuditLogRow>>(`${API_ROUTES.logs(workspaceId as string)}${toQuery(params)}`),
  });

/** Recent feed for the workspace dashboard (PRD §5.4). */
export const useRecentAuditLogs = (workspaceId: string | undefined, limit = AUDIT_DEFAULTS.recentLimit) =>
  useQuery({
    queryKey: [QUERY_KEYS.logs, workspaceId ?? "none", "recent", limit],
    enabled: Boolean(workspaceId),
    queryFn: () =>
      apiGet<Paginated<AuditLogRow>>(
        `${API_ROUTES.logs(workspaceId as string)}?page=1&pageSize=${limit}`,
      ),
  });
